import { render, staticRenderFns } from "./SubMenuItem.vue?vue&type=template&id=0ce3bc1d&scoped=true&"
import script from "./SubMenuItem.vue?vue&type=script&lang=js&"
export * from "./SubMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./SubMenuItem.vue?vue&type=style&index=0&id=0ce3bc1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce3bc1d",
  null
  
)

component.options.__file = "SubMenuItem.vue"
export default component.exports